import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import './AIFalsePositiveIcon.css';

export function AIFalsePositiveIcon({
  isVisible = false,
  tooltip = 'AI identified as false positive',
  aiAnalysisDescription = '',
}) {
  if (!isVisible) return null;

  // Create enhanced tooltip with analysis description if available
  const enhancedTooltip = aiAnalysisDescription
    ? `${tooltip}: ${aiAnalysisDescription}`
    : tooltip;

  return (
    <>
      <div
        className='ai-false-positive-icon'
        data-pr-tooltip={enhancedTooltip}
        data-pr-position='top'
      >
        <span className='ai-icon'>🤖</span>
        <span className='false-positive-indicator'>✓</span>
      </div>
      <Tooltip target='.ai-false-positive-icon' />
    </>
  );
}
